import { moment } from 'locale'
import type { Action } from 'redux'
import type { State } from 'store/types'
import { parseDateForRequest } from 'utils'

export const UPDATE_LAST_REFETCH_TIME = 'UPDATE_LAST_REFETCH_TIME'

export const selectLastReFetchTime = (store: State) => store.lastReFetchTime

const initialState = parseDateForRequest(moment(), true)

export default function lastReFetchTime(state = initialState, { type }: Action) {
  return type === UPDATE_LAST_REFETCH_TIME ? parseDateForRequest(moment(), true) : state
}
